/* eslint-disable import/prefer-default-export */
export function isIE() {
  return !!window.document.documentMode;
}
